import React from 'react'
import { AccordionContainer } from '../../../../../common/components/accordion/accordion.module'
import { InputLabelContainer } from '../../../../../common/components/form/label/containers/input-label.container'
import { InputContainer } from '../../../../../common/components/form/input/containers/input.container'
import { selectListItems } from '../../../../../redux/library/selector'
import { useSelector } from 'react-redux'
import { YesNoRendererComponent } from '../../../../../common/components/yes-no-renderer.component'

export default function LicenseBasicInfoComponent ({handleFormChange,domains,handleInnerFormChange,tenantsDetails}: any) {
const libraryData =useSelector(selectListItems)
  return (
    <>
      <AccordionContainer
        child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>

                    <div>
                    <InputLabelContainer
          label="Subscription Name"
      />
  <InputLabelContainer
      label={tenantsDetails?.SubscriptionName}
  />

                    </div>
                    </div>
                   
      }
        expandedPanel="Basic Info"
        headerTitle="Basic Info"
      />

  <AccordionContainer
      child={
          <div className="h-auto w-full bg-white  p-4 rounded">
          <table className="w-full text-xs bg-red-50">
              <thead className="w-full border-y border-black border-opacity-20">
                  <tr className="w-full text-left h-12">
                      <th className="px-3">S.NO</th>
                      <th className="px-3">DomainName</th>
                      <th className="px-3">Display Order</th>
                      <th className="px-3">IsEnabled</th>
                      <th className="px-3">Allowed Requests</th>
                      <th className="px-3">Used Requests</th>
                      {/* <th className="px-3">LicenseSubscriptionTypeId</th> */}
                  </tr>
              </thead>
              <tbody className="w-full h-auto">
                  {tenantsDetails?.LicenseSubscriptions?.map((TranscationItems: any, index: any) => (
                      <tr key={index} className="cursor-pointer h-16 even:bg-[#F8F9FAFF] odd:bg-white">
                          <td className="px-3">{index + 1}</td>
                          <td className="px-3"><InputContainer
                                        isDisabled
                                           labelField="Name"
                                           list={domains}
                                           onValueChange={(event: any, newValue: any) => {
                                            handleInnerFormChange(
                                                   event.target.value,
                                                   'DomainId',
                                               );
                                           }}
                                           optionName='Choose Domain Name'
                                           type="select"
                                           value={TranscationItems?.DomainId}
                                           valueField="Id"
                                       /></td>
                          <td className="px-3">{TranscationItems?.DisplayOrder}</td>
                          <td className="px-3">  <YesNoRendererComponent
              value={TranscationItems?.IsEnabled}
            /></td>
                          <td className="px-3">{TranscationItems?.AllowedRequests}</td>
                          <td className="px-3">{TranscationItems?.UsedRequests}</td>
                          {/* <td className="px-3">  <InputContainer
                    labelField="Text"
                    list={libraryData?.result?.SubscriptionType}
                    onValueChange={( event: any) => {
                        handleInnerFormChange(
                        event.target.value,
                       'LicenseSubscriptionTypeId'
                      );
                    }}
                    OptionName="Choose Subscription Type"
                    type="select"
                    valueField="Value"
                    value={TranscationItems?.LicenseSubscriptionTypeId}
/></td> */}
                          
                      </tr>
                  ))}
              </tbody>
          </table>
      </div>
     }
     expandedPanel="License Subscriptions"
     headerTitle="License Subscriptions"
   />    

<AccordionContainer
      child={
          <div className="h-auto w-full bg-white  p-4 rounded">
          <table className="w-full text-xs bg-red-50">
              <thead className="w-full border-y border-black border-opacity-20">
                  <tr className="w-full text-left h-12">
                      <th className="px-3">S.NO</th>
                      <th className="px-3">ServiceId</th>
                      <th className="px-3">Display Order</th>
                      <th className="px-3">IsEnabled</th>
                      <th className="px-3">Number Of Allowed ServiceRequests</th>
                      <th className="px-3">Number Of Used ServiceRequests</th>
                      {/* <th className="px-3">LicenseSubscriptionTypeId</th> */}
                  </tr>
              </thead>
              <tbody className="w-full h-auto">
                  {tenantsDetails?.ServiceAddOnSubscriptions?.map((TranscationItems: any, index: any) => (
                      <tr key={index} className="cursor-pointer h-16 even:bg-[#F8F9FAFF] odd:bg-white">
                          <td className="px-3">{index + 1}</td>
                          <td className="px-3">{TranscationItems?.ServiceId}</td>
                          <td className="px-3">{TranscationItems?.DisplayOrder}</td>
                          <td className="px-3">  <YesNoRendererComponent
              value={TranscationItems?.IsEnabled}
            /></td>
                          <td className="px-3">{TranscationItems?.NumberOfAllowedServiceRequests}</td>
                          <td className="px-3">{TranscationItems?.NumberOfUsedServiceRequests}</td>
                          {/* <td className="px-3">  <InputContainer
                    labelField="Text"
                    list={libraryData?.result?.SubscriptionType}
                    onValueChange={( event: any) => {
                        handleInnerFormChange(
                        event.target.value,
                       'ServiceAddOnSubscriptionTypeId'
                      );
                    }}
                    OptionName="Choose Subscription Type"
                    type="select"
                    valueField="Value"
                    value={TranscationItems?.ServiceAddOnSubscriptionTypeId}
/></td> */}
                          
                      </tr>
                  ))}
              </tbody>
          </table>
      </div>
     }
     expandedPanel="Service AddOn Subscriptions"
     headerTitle="Service AddOn Subscriptions"
   />  

<AccordionContainer
      child={
          <div className="h-auto w-full bg-white  p-4 rounded">
          <table className="w-full text-xs bg-red-50">
              <thead className="w-full border-y border-black border-opacity-20">
                  <tr className="w-full text-left h-12">
                      <th className="px-3">S.NO</th>
                      <th className="px-3">FeatureId</th>
                      <th className="px-3">Display Order</th>
                      <th className="px-3">IsEnabled</th>
                      <th className="px-3">Number Of Allowed ServiceRequests</th>
                      <th className="px-3">Number Of Used ServiceRequests</th>
                      {/* <th className="px-3">LicenseSubscriptionTypeId</th> */}
                  </tr>
              </thead>
              <tbody className="w-full h-auto">
                  {tenantsDetails?.FeatureAddOnSubscriptions?.map((TranscationItems: any, index: any) => (
                      <tr key={index} className="cursor-pointer h-16 even:bg-[#F8F9FAFF] odd:bg-white">
                          <td className="px-3">{index + 1}</td>
                          <td className="px-3">{TranscationItems?.ServiceId}</td>
                          <td className="px-3">{TranscationItems?.DisplayOrder}</td>
                          <td className="px-3">  <YesNoRendererComponent
              value={TranscationItems?.IsEnabled}
            /></td>
                          <td className="px-3">{TranscationItems?.NumberOfFeaturesAllowed}</td>
                          <td className="px-3">{TranscationItems?.NumberOfFeaturesUsed}</td>
                          {/* <td className="px-3">  <InputContainer
                    labelField="Text"
                    list={libraryData?.result?.SubscriptionType}
                    onValueChange={( event: any) => {
                        handleInnerFormChange(
                        event.target.value,
                       'ServiceAddOnSubscriptionTypeId'
                      );
                    }}
                    OptionName="Choose Subscription Type"
                    type="select"
                    valueField="Value"
                    value={TranscationItems?.ServiceAddOnSubscriptionTypeId}
/></td> */}
                          
                      </tr>
                  ))}
              </tbody>
          </table>
      </div>
     }
     expandedPanel="Feature AddOn Subscriptions"
     headerTitle="Feature AddOn Subscriptions"
   /> 
    </>
  )
}